var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback } from 'react';
import { MAX_UPLOAD_RATE } from '@lucidlink/sdk';
import { translate, useToastService } from '@lucidlink/uicore';
import { convertRateLimitToBytesPerSecond } from '#services';
import { parseRateLimitData } from '../../../../services/RateLimit';
import { useGlobalRateLimitMutations } from '../../hooks';
export const useGlobalUploadRateLimit = ({ data, filespaceId, workspaceId, }) => {
    _react_refresh_temp_1();
    const { addToast } = useToastService();
    const { defaultNumberValue, defaultUnitValue, initialNumberValue, initialUnitValue, isDefault, isDefaultUnlimited, isUnlimited, } = parseRateLimitData(data);
    const onError = useCallback(() => {
        addToast({
            kind: 'negative',
            content: {
                message: translate("Default value wasn't updated"),
            },
            'data-testid': 'filespace-global-upload-error',
        });
    }, [addToast]);
    const { isSuccess, setRateLimit, unsetRateLimit } = useGlobalRateLimitMutations({
        filespaceId,
        workspaceId,
        settingName: MAX_UPLOAD_RATE,
        onError,
    });
    const handleSave = useCallback((numberValue, unitValue) => {
        const bytesPerSecond = convertRateLimitToBytesPerSecond(numberValue, unitValue);
        setRateLimit(bytesPerSecond);
    }, [setRateLimit]);
    const label = translate('Upload rate limit');
    const labelDefault = isDefault ? translate('Default') : undefined;
    const labelTooltip = [
        translate('Controls the maximum transfer rate at which data is sent to the cloud storage. The default speed is unlimited.'),
    ];
    const resetToDefaultTooltip = isDefaultUnlimited
        ? translate('The default value is: Unlimited')
        : translate('The default value is: {{defaultNumberValue}} {{defaultUnitValue}}', {
            defaultUnitValue,
            defaultNumberValue,
        });
    const resetToDefault = isDefault
        ? undefined
        : {
            label: translate('Reset to default'),
            onReset: unsetRateLimit,
            tooltip: resetToDefaultTooltip,
        };
    const inlineFormValue = isUnlimited
        ? translate('Unlimited')
        : `${initialNumberValue} ${initialUnitValue}`;
    const scope = 'global';
    const type = 'upload';
    return {
        initialNumberValue,
        initialUnitValue,
        isUnlimited,
        inlineFormValue,
        label,
        labelDefault,
        labelTooltip,
        isSuccess,
        handleSave,
        resetToDefault,
        scope,
        type,
    };
};
_react_refresh_temp_1(useGlobalUploadRateLimit, "38kbUhE4lcsPQ3+AqE0Wh9TDBr0=", false, () => [useToastService, useGlobalRateLimitMutations]);
